export default __webpack_public_path__ + "static/10-things-to-do-in-singapore-in-10-hours-e6a121a790a0ba4799fef2913c8a42ad.jpg";